import BrandsCenteredContent from 'components/BrandsCenteredContent';
import Skeleton from 'components/Skeleton';
import useStyles from './styles';

const YoutubeVideoSkeleton = () => {
  const classes = useStyles();

  return (
    <BrandsCenteredContent>
      <div className={classes.skeletonRoot}>
        <Skeleton height={100} />
        <div className={classes.placeholder}>
          <div className={classes.button}>
            <Skeleton height={64} />
          </div>
        </div>
      </div>
    </BrandsCenteredContent>
  );
};

export default YoutubeVideoSkeleton;
